import {useAppSelector} from '../../../app/hooks/useAppSelector';
import {selectSession} from '../../auth/authSlice';
import {useBiotwinShare} from '../../biotwin-share/hooks/useBiotwinShare';
import {Biotwin} from '../types';

export const useReadOnly = () => {
  const session = useAppSelector(selectSession);
  const {canWrite, isIncoming} = useBiotwinShare();

  return {
    isReadOnly: (biotwin?: Biotwin) => {
      if (session?.isAdmin === 'true') {
        return false;
      }

      if (biotwin == null) {
        return false;
      }

      return biotwin.isDemo || biotwin.isSample || (isIncoming(biotwin) && !canWrite(biotwin));
    },
  };
};
